import { render, staticRenderFns } from "./OzRelativeTime.vue?vue&type=template&id=0e729c8e&"
import script from "./OzRelativeTime.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzRelativeTime.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports